import './styles/ViewEventGallery.scss';
import { System_DeviceOrientationMap } from '../../assets/keyMap';
import { AppContext, ExAppContext } from '../../Context';
import { ViewEventGallery_PageMap, ViewEventGallery_GalleryViewMode, ViewEventGallery_UserMode, EventItem_TypeMap, EventCategory_CategoryTypeMap, App_ViewModeMap } from '../../assets/keyMap';
import { Fragment, useContext, useState, useRef, useEffect, ReactElement } from 'react';
import { useHistory, useLocation } from 'react-router';
import { IonDate, IonDateFormat, IonDateString } from '../../components/IonDate';
import { Camera } from '@capacitor/camera';
import { Browser } from '@capacitor/browser';
import { ErrorLogger as elog, DebugLogger as dlog } from '../../components/Logger';
// import { Filesystem } from '@capacitor/filesystem';
import ImagePreviewer from '../../components/ImagePreviewer';
import BulkImagePreviewer from '../../components/BulkImagePreviewer';
import VideoPreviewer from '../../components/VideoPreviewer';

//classes
import EventItem from '../../exClasses/eventItem';
import Event from '../../exClasses/event';
import EventCategory from '../../exClasses/eventCategory';

//controllers
import DatabaseInterfaceController from '../../controllers/DatabaseInterfaceController';
import HelperFunctionsController from '../../controllers/HelperFunctionsController';

//mui icons
// import PanoramaIcon from '@mui/icons-material/Panorama';
// import CropFreeIcon from '@mui/icons-material/CropFree';
// import SquareIcon from '@mui/icons-material/Square'; ---deprecated of unused
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import UploadIcon from '@mui/icons-material/Upload';
import RemoveIcon from '@mui/icons-material/Remove';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';

//graphics
// import PPKMLogo from '../../assets/images/logos/ppkmLogo.jpg';
import { resolveSoa } from 'dns';
// import { GalleryPhoto } from '@capacitor/camera';

//photo gallery map
// import PPKMPhotoGalleryMap from '../../assets/others/ppkm_photo_gallery_map';


const nonstate = {
    fetchEventBatchSize: 10,
    viewModeToLabelMap: {
        1: '1 pic / row',
        2: '2 pics / row',
        3: '3 pics / row',
        4: '4 pics / row'
    },
    controlledImgSize: 500
}

interface Props {

}

const ViewEventGallery: React.FC<Props> = ({ }) => {
    //contexts
    const appContext = useContext(AppContext);
    const exAppContext = useContext(ExAppContext);
    //states - General
    const [filter_eventCategory, SetFilter_eventCategory] = useState<EventCategory | null>(null);
    const [filter_eventYear, SetFilter_eventYear] = useState<string | null>(null);
    const [filter_searchString, SetFilter_searchString] = useState<string>('');
    const [page, SetPage] = useState(ViewEventGallery_PageMap.CATEGORY_SELECTION);
    const [userMode, SetUserMode] = useState(ViewEventGallery_UserMode.MEMBER);
    const [shouldFastScrollBottom, SetShouldFastScrollBottom] = useState<boolean>(true);
    const [fetchEventOffset, SetFetchEventOffset] = useState<number>(0);
    const [recentEvents, SetRecentEvents] = useState([] as Event[]);
    const [selectedPreviewIndex, SetSelectedPreviewIndex] = useState(0);
    const [events, SetEvents] = useState([] as Event[]);
    const [selectedEvent, SetSelectedEvent] = useState({} as Event);
    const [selectedGallery, SetSelectedGallery] = useState({} as EventItem);
    const [galleryViewMode, SetGalleryViewMode] = useState<number>(ViewEventGallery_GalleryViewMode.TRIO);
    const [galleryScrollContents, SetGalleryScrollContents] = useState<any[]>([] as any[]);
    const [tehTarikTalkYears, SetTehTarikTalkYears] = useState([] as string[]);
    //states - EventGalleryManagement
    const [newEventPhotos, SetNewEventPhotos] = useState<string[]>([] as string[]);
    //references - vars
    const uploadPhotosCountRef = useRef<number>(0);
    const newEventPhotosRef = useRef<string[]>([] as string[]);
    const galleryScrollContentsRef = useRef<any[]>([] as any[]);

    //refs - objs
    const pageRef = useRef<any>(null);
    const canvasesRef = useRef<HTMLCanvasElement[]>([] as HTMLCanvasElement[]);
    const imagesRef = useRef([] as any);
    const uploadingPhotosCountRef = useRef<number>(0);
    //router objects
    const history = useHistory();
    const location = useLocation();
    //controller
    const database = new DatabaseInterfaceController(appContext);
    const helpers = new HelperFunctionsController();

    //watchers
    //test
    useEffect(() => {
        console.log('ViewEventGalleryTest: ' + JSON.stringify(appContext.databaseActionModeQueue));
    }, [appContext.databaseActionModeQueue]);

    //add scroll listener to pageRef
    useEffect(() => {
        //inject photo galleries to sync site-gallery
        // if(PPKMPhotoGalleryMap.length > 0) {
        //     PPKMPhotoGalleryMap.map((eventItem: any) => {
        //         databaseInterfaceController.Queue('injectEventItem', [
        //             ['injectEventItem', 'true'],
        //             ['eventID', eventItem.eventID],
        //             ['base_url', eventItem.base_url],
        //             ['file_names', eventItem.file_names]
        //         ]);
        //     });
        // }

        database.Queue('fetchLast10Events', [
            ['fetchLast10Events', 'true'],
        ]);

    }, []);

    //watch for pagelocation upate userMode
    useEffect(() => {
        if (location.pathname.includes('/Member'))
            SetUserMode(ViewEventGallery_UserMode.MEMBER);
        else if (location.pathname.includes('/Committee'))
            SetUserMode(ViewEventGallery_UserMode.COMMITTEE);

        const pathVars = location.pathname.split('/');
        if (pathVars.length >= 4) {
            const autoSelectedEvent = GetOngoingEventByID(pathVars[3]);
            if (Object.keys(autoSelectedEvent).length > 0) {
                SetSelectedEvent(autoSelectedEvent);
                SetFilter_eventCategory(GetEventCategoryByID(autoSelectedEvent.event_categoryID));
                SetPage(ViewEventGallery_PageMap.GALLERY);
            }
        }
    }, [location.pathname]);

    //watch for page change
    useEffect(() => {
        //reset 
        switch (page) {
            case ViewEventGallery_PageMap.CATEGORY_SELECTION:
                SetSelectedPreviewIndex(0);
                appContext.SetHeaderBackAction(() => () => { history.push('/Home'); });
                break;
            case ViewEventGallery_PageMap.YEAR_SELECTION:
                appContext.SetHeaderBackAction(() => () => OnBackToCategorySelectionClicked());
                SetFilter_eventYear(null);
                break;
            case ViewEventGallery_PageMap.EVENT_SELECTION:
                if (filter_eventYear == null)
                    appContext.SetHeaderBackAction(() => () => OnBackToCategorySelectionClicked());
                else
                    appContext.SetHeaderBackAction(() => () => OnBackToYearSelectionClicked());
                break;
            case ViewEventGallery_PageMap.GALLERY:
                //fetch event gallery
                if (Object.keys(selectedEvent).length > 0) {
                    database.Queue('fetchEventItemByEventIDAndType', [
                        ['fetchEventItemByEventIDAndType', 'true'],
                        ['eventID', selectedEvent.eventID],
                        ['type', EventItem_TypeMap.GALLERY]
                    ]);
                } else {
                    SetPage(ViewEventGallery_PageMap.EVENT_SELECTION);
                }

                //setup page back
                if(filter_eventCategory == null || Object.keys(filter_eventCategory).length == 0) 
                    appContext.SetHeaderBackAction(() => () => OnBackToCategorySelectionClicked());
                else
                    appContext.SetHeaderBackAction(() => () => OnBackToEventSelectionClicked());
                break;
            case ViewEventGallery_PageMap.UPLOAD_PHOTOS:
                //reset uploadAttemptPhotoCache
                newEventPhotosRef.current = [];
                SetNewEventPhotos(newEventPhotosRef.current);
                //set header back actions
                appContext.SetHeaderBackAction(() => () => SetPage(ViewEventGallery_PageMap.GALLERY));
                break;
        }
    }, [page, selectedEvent]);

    //watch for batchRecordLimit update fetchEvents from server
    // useEffect(() => {
    //     databaseInterfaceController.Queue('fetchOngoingAndPastEventsByBatch', [
    //         ['fetchOngoingAndPastEventsByBatch', 'true'],
    //         ['offset', fetchEventOffset],
    //         ['batchSize', nonstate.fetchEventBatchSize]
    //     ]);
    // }, [fetchEventOffset]); ---deprecated to fetchEventsByCategory

    //watch for filterEventCategoryUpdate, fetchEventsByEventCategory
    useEffect(() => {
        if (filter_eventCategory != null) {
            if (filter_eventCategory.event_categoryID != '10') {
                database.Queue('fetchEventsByCategory', [
                    ['fetchEventsByCategory', 'true'],
                    ['event_categoryID', filter_eventCategory.event_categoryID]
                ]);
            } else {
                database.Queue('fetchEventsStartDateByCategory', [
                    ['fetchEventsStartDateByCategory', 'true'],
                    ['event_categoryID', filter_eventCategory.event_categoryID]
                ]);
            }
        }
    }, [filter_eventCategory]);

    //watch for filterEventYear filterEventCategory fetchEvents from server
    useEffect(() => {
        if (
            filter_eventYear != null
            && filter_eventCategory != null
        ) {
            database.Queue('fetchEventsByCategoryAndYear', [
                ['fetchEventsByCategoryAndYear', 'true'],
                ['event_categoryID', filter_eventCategory.event_categoryID],
                ['year', filter_eventYear]
            ]);
        }
    }, [filter_eventYear, filter_eventCategory]);

    //watch for selected gallery && galleryViewMode updateScrollContent
    useEffect(() => {
       if(Object.keys(selectedGallery).length > 0 && selectedGallery.file_names.length > 0) {
            galleryScrollContentsRef.current = [] as ReactElement[];
            const srcs = [] as string[]
            selectedGallery.file_names.map((fileName: string) => {if(!fileName.includes('https')) srcs.push(selectedGallery.base_url + fileName)});

            selectedGallery.file_names.map((fileName: string, i: number) => {
                const url = fileName.includes('https') ? fileName : (selectedGallery.base_url + fileName);

                helpers.CheckMediaType(url).then((res: string) => {
                    switch(res) {
                        case 'image':
                            galleryScrollContentsRef.current.push(
                                <div key={'gallery-content-img-' + i} className={'gallery-content-img ' + GetObjKeyOfVal(ViewEventGallery_GalleryViewMode, galleryViewMode.toString())}>
                                    <BulkImagePreviewer src={url} srcs={srcs} index={i} downloadable={false} shareable={false} />
                                    {
                                        exAppContext.viewMode == App_ViewModeMap.COMMITTEE ?
                                            <button className={'gallery-content-btn ' + GetObjKeyOfVal(ViewEventGallery_GalleryViewMode, galleryViewMode.toString())} onClick={() => OnRemoveGalleryItemClicked(i)}><RemoveIcon /></button>
                                            :
                                            null
                                    }
                                </div>
                            );
                            break;
                        case 'video':
                                galleryScrollContentsRef.current.push(
                                    <div key={'gallery-content-img-' + i} className={'gallery-content-img ' + GetObjKeyOfVal(ViewEventGallery_GalleryViewMode, galleryViewMode.toString())}>
                                        <VideoPreviewer className='gallery-content-video' src={url}/>
                                    </div>
                                );
                            break;
                        default:
                            elog('CheckMediaTypeErr mediaTypeErr ' + res);
                            break;
                    }

                    SetGalleryScrollContents([...galleryScrollContentsRef.current]);
                }).catch((err: string) => {
                    elog('CheckMediaTypeErr ' + err);
                });
            });
       } 
    }, [selectedGallery, galleryViewMode]);

    //watch for database result actions
    useEffect(() => {
        if (appContext.databaseActionModeQueue.length > 0 && appContext.databaseResultAction != null) {
            const ExecuteDatabaseResultAction = async () => {
                const [res, mode] = await appContext.databaseResultAction();
                switch (mode) {
                    case 'fetchEventsByCategoryAndYear':
                    case 'fetchEventsByCategory':
                        if (!JSON.stringify(res).includes('_false')) {
                            let objArr = [] as any[];
                            try {
                                objArr = JSON.parse(res) as any[];
                            } catch {
                                objArr = res as any[];
                            }
                            const _events = [] as Event[];
                            objArr.map((obj: any) => {
                                _events.push(new Event(
                                    obj['eventID'],
                                    obj['event_categoryID'],
                                    obj['event_name'],
                                    obj['event_name_highlight_texts'],
                                    obj['event_name_highlight_colors'],
                                    obj['event_desc'],
                                    obj['event_poster'],
                                    obj['event_file'],
                                    obj['event_venue'],
                                    obj['registration_start_date'],
                                    obj['registration_end_date'],
                                    obj['early_bird_start_date'],
                                    obj['early_bird_end_date'],
                                    obj['event_start_date'],
                                    obj['event_end_date'],
                                    obj['event_schedules'],
                                    obj['max_pax'],
                                    obj['hostID'],
                                    obj['datetime_created'],
                                    obj['datetime_updated'],
                                    obj['inapp_purchase'],
                                    obj['external_link_url'],
                                    obj['first_gallery_img'] != undefined ? obj['first_gallery_img'] : ''
                                ));
                            });
                            SetEvents(_events);
                        } else {
                            console.log('fetchEventsErr: ' + res);
                        }
                        break;
                    case 'fetchEventItemByEventIDAndType':
                        if (!JSON.stringify(res).includes('_false')) {
                            let resObj = {} as any;
                            try {
                                resObj = JSON.parse(res) as any;
                            } catch {
                                resObj = res as any;
                            }

                            if (Object.keys(resObj).length > 0) {
                                SetSelectedGallery(new EventItem(
                                    resObj['itemID'],
                                    resObj['eventID'],
                                    resObj['base_url'],
                                    resObj['file_names'],
                                    resObj['datetime_expired'],
                                    resObj['type']
                                ));
                            } else {
                                SetSelectedGallery({} as EventItem);
                            }
                        } else {
                            console.log('fetchEventItemByEventIDAndTypeErr: ' + res);
                        }
                        break;
                    case 'uploadEventPhoto':
                        if (!JSON.stringify(res).includes('_false')) {
                            uploadPhotosCountRef.current -= 1;
                            if (uploadPhotosCountRef.current > 0) {
                                database.Queue('uploadEventPhoto', [
                                    ['uploadEventPhoto', 'true'],
                                    ['initiatorID', appContext.user.userID],
                                    ['eventID', selectedEvent.eventID],
                                    ['photoBase64', newEventPhotosRef.current[newEventPhotosRef.current.length - uploadPhotosCountRef.current], false] //3rd param false, set encryption -> false
                                ]);
                                appContext.SetWaitScreenMessage('Uploading photos ' + (uploadingPhotosCountRef.current - uploadPhotosCountRef.current) + '/' + uploadingPhotosCountRef.current + '\nDo not turn off the app');
                            } else {
                                appContext.SetPopupMessage('Successfully uploaded all event photos.');
                                appContext.SetWaitScreenShouldShow(false);
                                appContext.SetDatabaseShouldShowWaitScreen(true);
                                SetPage(ViewEventGallery_PageMap.GALLERY);

                                //refetch eventItems
                                database.Queue('fetchEventItemByEventIDAndType', [
                                    ['fetchEventItemByEventIDAndType', 'true'],
                                    ['eventID', selectedEvent.eventID],
                                    ['type', EventItem_TypeMap.GALLERY]
                                ]);
                            }
                        } else {
                            appContext.SetPopupMessage('Event photos upload failed, please try again later.');
                            uploadPhotosCountRef.current = 0;
                            appContext.SetWaitScreenShouldShow(false);
                            appContext.SetDatabaseShouldShowWaitScreen(true);
                            console.log('uploadEventPhotoErr: ' + res);
                        }
                        break;
                    case 'updateEventItemFileNames':
                        if (!JSON.stringify(res).includes('_false')) {
                            appContext.SetPopupMessage('Successfully removed the selected photo.');
                            //refetch eventItems
                            database.Queue('fetchEventItemByEventIDAndType', [
                                ['fetchEventItemByEventIDAndType', 'true'],
                                ['eventID', selectedEvent.eventID],
                                ['type', EventItem_TypeMap.GALLERY]
                            ]);
                        } else {
                            appContext.SetPopupMessage('Fail to remove the selected photo, please try again later.');
                            console.log('updateEventItemFileNamesErr: ' + res);
                        }
                        break;
                    case 'deleteEventItem':
                        // if(!JSON.stringify(res).includes('_false')) {
                        //     appContext.SetPopupMessage('Successfuly removed all event photos.');
                        //     //refetch eventItems
                        //     databaseInterfaceController.Queue('fetchEventItemByEventIDAndType', [
                        //         ['fetchEventItemByEventIDAndType', 'true'],
                        //         ['eventID', selectedEvent.eventID],
                        //         ['type', EventItem_TypeMap.GALLERY]
                        //     ]);
                        // } else {
                        //     appContext.SetPopupMessage('Fail to remove all event photos, please try again later.');
                        //     console.log('deleteEventItemErr: ' + res);
                        // }
                        appContext.SetPopupMessage('Successfully removed all event photos.');
                        //refetch eventItems
                        database.Queue('fetchEventItemByEventIDAndType', [
                            ['fetchEventItemByEventIDAndType', 'true'],
                            ['eventID', selectedEvent.eventID],
                            ['type', EventItem_TypeMap.GALLERY]
                        ]);
                        break;
                    case 'injectEventItem':
                        if (!JSON.stringify(res).includes('_false')) {
                            console.log('successfully injected a new eventItem!');
                        } else {
                            console.log('fails to inject a new eventItem!');
                        }
                        break;
                    case 'fetchEventsStartDateByCategory':
                        if (!JSON.stringify(res).includes('_false')) {
                            let resArrs = [];
                            try {
                                resArrs = JSON.parse(res) as string[];
                            } catch {
                                resArrs = res as string[];
                            }
                            const years = [] as string[];

                            resArrs.map((_res: string) => {
                                const resYear = IonDateString(IonDate(_res + ' 00:00:00'), IonDateFormat.YEAR_ONLY);
                                let isFound = false;
                                years.map((year: string) => {
                                    if (year == resYear)
                                        isFound = true;
                                });

                                if (!isFound && years.length < 3)
                                    years.push(resYear);
                            });
                            SetTehTarikTalkYears([...years]);
                        } else {
                            console.log('fetchEventsStartDateByCategoryErr: ' + res);
                        }
                        break;
                    case 'fetchLast10Events':
                        if(!JSON.stringify(res).includes('_false')) {
                            let resObjs = [] as any[];
                            try {
                                resObjs =  JSON.parse(res) as any[];
                            } catch {
                                resObjs = res as any[];
                            }
                            const _events = [] as Event[];
                            resObjs.map((obj: any) => {
                                _events.push(new Event(
                                    obj['eventID'],
                                    obj['event_categoryID'],
                                    obj['event_name'],
                                    obj['event_name_highlight_texts'],
                                    obj['event_name_highlight_colors'],
                                    obj['event_desc'],
                                    obj['event_poster'],
                                    obj['event_file'],
                                    obj['event_venue'],
                                    obj['registration_start_date'],
                                    obj['registration_end_date'],
                                    obj['early_bird_start_date'],
                                    obj['early_bird_end_date'],
                                    obj['event_start_date'],
                                    obj['event_end_date'],
                                    obj['event_schedules'],
                                    obj['max_pax'],
                                    obj['hostID'],
                                    obj['datetime_created'],
                                    obj['datetime_updated'],
                                    obj['inapp_purchase'],
                                    obj['external_link_url'],
                                    obj['first_gallery_img'] != undefined ? obj['first_gallery_img'] : ''
                                ));
                            });
                            SetRecentEvents(_events);
                        } else {
                            console.log('fetchLast10EventsErr ' + res);
                        }
                        break;
                }
            };

            switch (appContext.databaseActionModeQueue[0]) {
                case 'fetchEventsByCategoryAndYear':
                case 'fetchEventsByCategory':
                case 'fetchEventItemByEventIDAndType':
                case 'uploadEventPhoto':
                case 'updateEventItemFileNames':
                case 'deleteEventItem':
                case 'injectEventItem':
                case 'fetchEventsStartDateByCategory':
                case 'fetchLast10Events':
                    ExecuteDatabaseResultAction();
                    break;
            }
        }
    }, [appContext.databaseActionModeQueue, appContext.databaseResultAction]);

    //ui functions
    const OnEventCategorySelected = (eventCategory: EventCategory | null) => {

        if (
            eventCategory
            && (eventCategory.event_categoryID != '20' && eventCategory.event_categoryID != '10')
        ) {
            SetFilter_eventCategory(eventCategory);
            SetPage(ViewEventGallery_PageMap.EVENT_SELECTION);
        } else if (
            eventCategory
            && eventCategory.event_categoryID == '20'
        ) {
            Browser.open({ url: 'https://www.ppkm.org.my/site/ppkm-awards-gallery/' });
        } else if (
            eventCategory
            && eventCategory.event_categoryID == '10'
        ) {
            SetFilter_eventCategory(eventCategory);
            SetPage(ViewEventGallery_PageMap.YEAR_SELECTION);
        }
    }
    const OnBackToCategorySelectionClicked = () => {
        SetFilter_eventCategory({} as EventCategory);
        SetPage(ViewEventGallery_PageMap.CATEGORY_SELECTION);
    }
    const OnYearSelectionClicked = (year: string) => {
        SetFilter_eventYear(year);
        SetPage(ViewEventGallery_PageMap.EVENT_SELECTION);
    }
    const OnEventSelectionClicked = (event: Event) => {
        SetSelectedEvent(event);
        SetPage(ViewEventGallery_PageMap.GALLERY);
    }
    const OnBackToYearSelectionClicked = () => {
        SetSelectedEvent({} as Event);
        SetPage(ViewEventGallery_PageMap.YEAR_SELECTION);
    }
    const OnBackToEventSelectionClicked = () => {
        SetSelectedGallery({} as EventItem);
        SetSelectedEvent({} as Event);
        SetPage(ViewEventGallery_PageMap.EVENT_SELECTION);
    }
    const OnViewModeSwitchClicked = () => {
        switch (galleryViewMode) {
            case ViewEventGallery_GalleryViewMode.UNO:
                SetGalleryViewMode(ViewEventGallery_GalleryViewMode.DUO);
                break;
            case ViewEventGallery_GalleryViewMode.DUO:
                SetGalleryViewMode(ViewEventGallery_GalleryViewMode.TRIO);
                break;
            case ViewEventGallery_GalleryViewMode.TRIO:
                SetGalleryViewMode(ViewEventGallery_GalleryViewMode.QUAD);
                break;
            case ViewEventGallery_GalleryViewMode.QUAD:
                SetGalleryViewMode(ViewEventGallery_GalleryViewMode.UNO);
                break;
        }
    }
    const OnUploadEventPhotosClicked = async () => {
        appContext.SetAppStateChangeWatch(false);
        SetPage(ViewEventGallery_PageMap.UPLOAD_PHOTOS);

        await Camera.pickImages({}).then((res: any) => {
            appContext.SetWaitScreenMessage('please wait');
            appContext.SetWaitScreenShouldShow(true);
            //clear up and reset
            canvasesRef.current = [];
            imagesRef.current = [];
            uploadingPhotosCountRef.current = res.photos.length;
            appContext.SetWaitScreenMessage('importing photos please wait');
            res.photos.map((photo: any, i: number) => {
                Resize(photo.webPath ? photo.webPath : '');
            });
            // const _res = res.photos[0];
            // Resize(_res.webPath ? _res.webPath : '');
        });
    }
    const OnProceedUploadPhotosClicked = () => {
        uploadPhotosCountRef.current = newEventPhotosRef.current.length;
        appContext.SetDatabaseShouldShowWaitScreen(false);
        appContext.SetWaitScreenMessage('Uploading event photos\ndo not turn off the app');
        appContext.SetWaitScreenShouldShow(true);
        setTimeout(() => {
            database.Queue('uploadEventPhoto', [
                ['uploadEventPhoto', 'true'],
                ['initiatorID', appContext.user.userID],
                ['eventID', selectedEvent.eventID],
                ['photoBase64', newEventPhotosRef.current[newEventPhotosRef.current.length - uploadPhotosCountRef.current], false]
            ]);
        }, 500);
    }
    const OnDiscardUploadPhotosClicked = () => {
        appContext.SetPopupMessage('Are you sure to cancel photo upload session?\nUpdate will not be saved');
        appContext.SetPopupButtons(['Yes', 'No']);
        appContext.SetPopupActions([() => {
            SetPage(ViewEventGallery_PageMap.GALLERY);
        }, () => { }]);
    }
    const OnRemoveNewEventPhotosClicked = (i: number) => {
        newEventPhotosRef.current.splice(i, 1);
        SetNewEventPhotos([...newEventPhotosRef.current]);
    }
    const OnRemoveGalleryItemClicked = (fileIndex: number) => {
        appContext.SetPopupMessage('Are you sure to remove the selected gallery item?');
        appContext.SetPopupButtons(['Yes', 'No']);
        appContext.SetPopupActions([() => {
            //proceed remove galleryItem file
            let updatedFileNames = (selectedGallery.file_names.join(',')).split(',');
            updatedFileNames.splice(fileIndex, 1);
            const fileNameRemoved = selectedGallery.file_names[fileIndex];

            database.Queue('updateEventItemFileNames', [
                ['updateEventItemFileNames', 'true'],
                ['initiatorID', appContext.user.userID],
                ['itemID', selectedGallery.itemID],
                ['file_names', updatedFileNames.join(',')],
                ['eventID', selectedGallery.eventID],
                ['fileNameRemoved', fileNameRemoved]
            ]);
        }, () => { }]);
    }
    const OnDeleteGalleryItemClicked = () => {
        appContext.SetPopupMessage('Are you sure to remove all photos for ' + selectedEvent.event_name + '?');
        appContext.SetPopupButtons(['Yes', 'No']);
        appContext.SetPopupActions([() => {
            //proceed remove entire galleryItem record
            database.Queue('deleteEventItem', [
                ['deleteEventItem', 'true'],
                ['initiatorID', appContext.user.userID],
                ['itemID', selectedGallery.itemID],
                ['fileNames', selectedGallery.file_names.join(',')],
                ['eventID', selectedGallery.eventID]
            ]);
        }, () => { }]);
    }

    //render functions
    const RenderPage = () => {
        switch (page) {
            default:
            case ViewEventGallery_PageMap.CATEGORY_SELECTION:
                return RenderCategorySelectionPage();
            case ViewEventGallery_PageMap.YEAR_SELECTION:
                return RenderYearSelectionPage();
            case ViewEventGallery_PageMap.EVENT_SELECTION:
                return RenderEventSelectionPage();
            case ViewEventGallery_PageMap.GALLERY:
                return RenderGalleryPage();
            case ViewEventGallery_PageMap.UPLOAD_PHOTOS:
                return RenderUploadPhotosPage();
        }
    }
    const RenderPageTitle = () => {
        switch (page) {
            case ViewEventGallery_PageMap.CATEGORY_SELECTION:
                return (
                    <div className='page-title-block'>
                        <span className='title-lbl'>EVENT CATEGORY SELECTION</span>
                    </div>
                );
            case ViewEventGallery_PageMap.YEAR_SELECTION:
                return (
                    <div className='page-title-block'>
                        <span className='title-lbl'>Teh Tarik Talks</span>
                    </div>
                );
            case ViewEventGallery_PageMap.EVENT_SELECTION:
                return (
                    <div className='page-title-block'>
                        <span className='title-lbl'>EVENT SELECTION</span>
                    </div>
                );
            case ViewEventGallery_PageMap.GALLERY:
                return (
                    <div className='page-title-block'>
                        <span className='title-lbl'>{selectedEvent.event_name}</span>
                    </div>
                );
        }
    }
    const RenderCategorySelectionPage = () => {
        return (
            <Fragment>
                {RenderRecentEventsGalleryPreviewer()}
                <div className='page category-selection' ref={pageRef}>
                    {RenderPageTitle()}
                    {
                        exAppContext.eventCategories.map((eventCategory: EventCategory, i: number) => {
                            return (
                                eventCategory.event_category_type == EventCategory_CategoryTypeMap.EVENT ?
                                    <button className='selection-btn' key={'selection-btn-' + i} onClick={() => OnEventCategorySelected(eventCategory)}>{eventCategory.event_category_name}</button>
                                    :
                                    null
                            )
                        })
                    }
                </div>
            </Fragment>
        )
    }
    const RenderRecentEventsGalleryPreviewer = () => {
        return (
            <div className='recent-events-gallery-previewer' onScroll={(e: any) => {
                const el = e.currentTarget;
                const current = el.scrollLeft;
                const max = el.scrollWidth - el.clientWidth;

                const _recentEvents = FilterRecentEvents(recentEvents);
                const _selectedPreviewIndex = Math.round(current/max * (_recentEvents.length - 1));
                SetSelectedPreviewIndex(_selectedPreviewIndex);
            }}>
                {
                    FilterRecentEvents(recentEvents).map((event: Event, i: number) => {
                        return(
                            RenderEventSelectionBtn(event, i, (i == selectedPreviewIndex? true : false))
                        )
                    })                    
                }
            </div>
        )
    }
    const RenderYearSelectionPage = () => {
        return (
            <div className='page category-selection ex' ref={pageRef}>
                {RenderPageTitle()}
                {
                    tehTarikTalkYears.map((year: string, i: number) => {
                        if (i < 3) {
                            return (
                                <button className='selection-btn' key={'selection-btn-' + i} onClick={() => OnYearSelectionClicked(year)}>{'TTT & Webinars Gallery\nYear ' + year}</button>
                            )
                        }
                    })
                }
            </div>
        )
    }
    const RenderEventSelectionPage = () => {
        const filteredEvents = FilterEventsBySearchString(events);

        return (
            <div className="page event-selection" ref={pageRef}>
                {RenderPageTitle()}
                <div className='event-page-search-bar'>
                    <input className='event-page-search-in' value={filter_searchString} onChange={(e: any) => SetFilter_searchString(e.target.value)} placeholder='type to search' onFocus={() => SetFilter_searchString('')} />
                    <SearchIcon />
                </div>
                {
                    appContext.deviceOrientation == System_DeviceOrientationMap.LANDSCAPE ? <div style={{width: '100%'}}></div>:null
                }
                {
                    filteredEvents.length > 0 ?
                        filteredEvents.map((event: Event, i: number) => {
                            if (event.first_gallery_img != '')
                                return RenderEventSelectionBtn(event, i)
                            else
                                return null;
                        })
                        :
                        <span className='no-event-found-lbl'>No events found<br />Please check again later</span>
                }
            </div>
        );
    }
    const RenderGalleryPage = () => {
        return (
            <div className='page gallery-page' ref={pageRef}>
                {RenderPageTitle()}
                {
                    galleryScrollContents.length > 0 ?
                        <div className='gallery-container'>
                            {galleryScrollContents}
                        </div>
                        :
                        <span className='no-photos-lbl'>No photos to be shown at the moment<br />Please check again later</span>
                }
                <div className='gallery-page-option-panel'>
                    {
                        Object.keys(selectedGallery).length > 0 ?
                            <button className='gallery-page-option-btn' onClick={() => OnViewModeSwitchClicked()}>
                                {nonstate.viewModeToLabelMap[galleryViewMode as keyof typeof nonstate.viewModeToLabelMap]}
                            </button>
                            :
                            null
                    }
                    {
                        userMode == ViewEventGallery_UserMode.COMMITTEE ?
                            <Fragment>
                                <button className='gallery-page-option-btn' onClick={() => OnUploadEventPhotosClicked()}><AddIcon /> Upload Images</button>
                                {
                                    Object.keys(selectedGallery).length > 0 && selectedGallery.file_names.length > 0 ?
                                        <button className='gallery-page-option-btn' onClick={() => OnDeleteGalleryItemClicked()}><DeleteIcon /> Delete All</button>
                                        :
                                        null
                                }
                            </Fragment>
                            :
                            null
                    }
                </div>
            </div>
        )
    }
    const RenderUploadPhotosPage = () => {

        const scrollContent = [] as ReactElement[];
        if (Object.keys(newEventPhotos).length > 0) {
            newEventPhotos.map((base64String: string, i: number) => {
                scrollContent.push(
                    <div className={'gallery-content-img TRIO'}>
                        <ImagePreviewer src={base64String} />
                        <button className='gallery-content-btn' onClick={() => OnRemoveNewEventPhotosClicked(i)}><RemoveIcon /></button>
                    </div>
                );
            });
        }
        return (
            <div className='page upload-page' ref={pageRef}>
                {
                    scrollContent.length > 0 ?
                        <div className='gallery-container'>
                            {scrollContent}
                        </div>
                        :
                        <span className='no-photos-lbl'>No photos selected<br />Click 'select images'<br />to select photos.</span>
                }
                <div className='upload-page-option-panel'>
                    {
                        userMode == ViewEventGallery_UserMode.COMMITTEE ?
                            <button className='upload-page-option-btn' onClick={() => OnUploadEventPhotosClicked()}><AddIcon />Select Images</button>
                            :
                            null
                    }
                    <button className='upload-page-option-btn' onClick={() => OnProceedUploadPhotosClicked()}><UploadIcon />Upload</button>
                </div>
                <button className='upload-page-close-btn' onClick={() => OnDiscardUploadPhotosClicked()}><CloseIcon /></button>
            </div>
        )
    }
    const RenderEventSelectionBtn = (event: Event, i: number, selected?: boolean) => {
        return (
            <button className={'event-selection-btn ' + (selected? 'selected' : '')} key={'event-selection-btn-' + i} onClick={() => OnEventSelectionClicked(event)}>
                <img className='event-poster-img' src={event.first_gallery_img} />
                <div className='event-title-block'>
                    <span className='event-title-lbl'>{event.event_name}</span>
                </div>
            </button>
        )
    }

    //exe functions
    const GetObjKeyOfVal = (obj: any, val: string) => {
        let res = '';
        Object.keys(obj).map((key: string) => {
            if (obj[key] == val) {
                res = key;
            }
        });
        return res;
    }
    const FilterEventsBySearchString = (events: Event[]) => {
        let res = [] as Event[];
        if (SetFilter_searchString.length > 0) {
            events.map((event: Event) => {
                if (
                    event.event_name.toLowerCase().includes(filter_searchString)
                    || event.event_desc.toLowerCase().includes(filter_searchString)
                ) {
                    res.push(event);
                }
            });
        } else {
            res = events;
        }
        return res;
    }
    const FilterEventsByEventCategory = (events: Event[]) => {
        let res = [] as Event[];
        if (filter_eventCategory != null) {
            events.map((event: Event) => {
                if (event.event_categoryID == filter_eventCategory.event_categoryID) {
                    res.push(event);
                }
            });
        } else {
            res = events;
        }
        return res;
    }
    const FilterRecentEvents = (events: Event[]) => {
        const res = [] as Event[];
        events.map((event: Event) => {
            if(event.first_gallery_img != '')
                res.push(event);
        });

        return res;
    }
    const Resize = (imgUrl: string) => {
        const index = canvasesRef.current.length;
        canvasesRef.current.push(document.createElement('canvas'));

        if (canvasesRef.current.length > 0) {
            const context = canvasesRef.current[index].getContext('2d');

            //process image
            if (imgUrl != '') {
                imagesRef.current.push(new Image());
                imagesRef.current[index].src = imgUrl;
                imagesRef.current[index].onload = () => {
                    //get image profile
                    let [orientation, img_width, img_height] = GetImageProfile(imagesRef.current[index]);
                    const w_h_ratio = img_width / img_height;
                    const shouldDrawTillXPos = (orientation == 'portrait' ? nonstate.controlledImgSize : w_h_ratio * nonstate.controlledImgSize);
                    const shouldDrawTillYPos = (orientation == 'landscape' ? nonstate.controlledImgSize : nonstate.controlledImgSize / w_h_ratio);

                    canvasesRef.current[index].width = shouldDrawTillXPos; canvasesRef.current[index].height = shouldDrawTillYPos;

                    if (context) {
                        context.drawImage(
                            imagesRef.current[index],
                            // orientation == 'portrait' ? 0 : offset, //grab ori image pos X
                            // orientation == 'landscape' ? 0 : offset,//grab ori image pos Y --deprecated, only apply in crop
                            0, 0,
                            img_width, img_height,
                            0, 0, //start draw from canvas pos 
                            shouldDrawTillXPos,
                            shouldDrawTillYPos //draw till canvas dimension);
                        );
                        if (canvasesRef.current[index]) {
                            const imgBase64String = canvasesRef.current[index].toDataURL();
                            newEventPhotosRef.current.push(imgBase64String);
                            SetNewEventPhotos([...newEventPhotosRef.current]);
                        }
                    }

                    //check is last image loaded
                    if (imagesRef.current.length == uploadingPhotosCountRef.current) {
                        appContext.SetWaitScreenShouldShow(false);
                    }
                }
            }
        }
    }
    const GetImageProfile = (image: HTMLImageElement): [string, number, number] => {

        let orientation: string = '';
        let img_width: number = 0;
        let img_height: number = 0;
        let grabOffset: number = 0;

        if (image.height >= image.width) {
            //is a portrait or square
            orientation = 'portrait';
        } else {
            //is a landscape
            orientation = 'landscape';
        }
        img_width = image.width; img_height = image.height;

        return [orientation, img_width, img_height];
    }
    const GetOngoingEventByID = (eventID: string) => {
        let res = {} as Event;
        exAppContext.ongoingEvents.map((event: Event) => {
            if (event.eventID == eventID)
                res = event;
        });
        return res;
    }
    const GetEventCategoryByID = (event_categoryID: string) => {
        let res = {} as EventCategory;
        exAppContext.eventCategories.map((category: EventCategory) => {
            if (category.event_categoryID == event_categoryID)
                res = category;
        });
        return res;
    }
    // const Base64StringSize = (base64String: string) => {
    //     return (base64String.length * 3 / 4).toString() + ' bytes';
    // } ---deprecated

    return (
        <div className={'ViewEventGallery ' + (appContext.deviceOrientation == System_DeviceOrientationMap.LANDSCAPE ? 'landscape' : 'portrait')}>
            {
                RenderPage()
            }
        </div>
    )
}
export default ViewEventGallery;